// extracted by mini-css-extract-plugin
export default {"root":"LeftSide_root__ejf+4","mobile":"LeftSide_mobile__7kQZx","desktop":"LeftSide_desktop__5snvZ"};